import { Link } from "react-router-dom";

export const Category = ({ title, image, to }) => {
  return (
    <li>
      <Link to={to} className="group block overflow-hidden">
        <img
          src={
            image ??
            "https://images.unsplash.com/photo-1524758631624-e2822e304c36?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
          }
          alt={title}
          class="h-[350px] w-full object-cover transition duration-500 group-hover:scale-105 sm:h-[450px]"
        />

        <div class="relative bg-white pt-3">
          <h3 class="text-gray-900">{title}</h3>
        </div>
      </Link>
    </li>
  );
};
